import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import mutator from 'mutator';
import { GET_TRACK_NOTIFICATIONS } from '../queries/get-track-notifications';

export default graphql(
  gql`
    mutation CreateTextMessage($input: CreateTextMessage!) {
      createTextMessage(input: $input) {
        id
        message
        title
        date
        series_id
        track_id
        unixTimestamp
        series
        track
        event
        list
        num_users
        type
      }
    }
  `,
  {
    props: ({ mutate }) => ({
      createTextMessage: async (input) => {
        return mutator(() =>
          mutate({
            variables: { input },
            update: (proxy, { data: { createTextMessage } }) => {
              try {
                const data = proxy.readQuery({
                  query: GET_TRACK_NOTIFICATIONS,
                  variables: { input: {} },
                });

                proxy.writeQuery({
                  query: GET_TRACK_NOTIFICATIONS,
                  variables: { input: {} },
                  data: {
                    ...data,
                    getTrackNotificationsV2: {
                      ...data.getTrackNotificationsV2,
                      count: data.getTrackNotificationsV2.count + 1,
                      results: [createTextMessage].concat(
                        data.getTrackNotificationsV2.results
                      ),
                    },
                  },
                });
              } catch (error) {
                console.error(error);
              }
            },
          })
        );
      },
    }),
  }
);
